export default "__VITE_ASSET__DBtcKEvK__"